import { JSONTree } from "react-json-tree";
import { custheme } from "../service/constants";
import { useEffect, useState } from "react";
const TreeViewer = ({ data }) => {
    const [treeData, setTreeData] = useState(null)
    useEffect(() => {
     setTreeData(data)
    }, [data])
    
    const rootKey = treeData?.resource?.resourceType;
    const transformedData = {
        [rootKey]:{
            ...treeData
        }
    }
    
    return (
        <div >
            <JSONTree data={transformedData}  hideRoot theme={custheme} />
        </div>
    )
}

export default TreeViewer